import axios from "@/axios.js";

export default {

  fetchDataListItems({ commit }) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .get("API/OwnerPayment/GetOwnersPaymentLogs")
        .then(response => {
          debugger;
          resolve(response);
          commit("SET_OwnersPaymentLogs", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
        .post("API/OwnerPayment/AddOwnerUnitPayment", item)
        .then(response => {
          debugger;
          resolve(response);
          commit(
            "ADD_ITEM",
            Object.assign(item, { ID: response.data.data.ID })
          );
        })
        .catch(error => {
          reject(error);
        });
    });
  },

};
